import { IProduct } from '../../types/product';
import IconButton from '../../components/common/Buttons/IconButton';
import { IRequestInfo } from '../../types/requester';
import { Roles } from '../../utils/enums';
import { STATUSES } from '../../utils/constants';
interface BottombarProps {
    products?: Array<IProduct>;
    approved: number;
    rejected: number;
    pending: number;
    request: IRequestInfo | null;
    handleSubmitRequest?: () => void;
    userType?: string;
}

const ProductsBottombar = ({ approved, rejected, userType, request, products, pending, handleSubmitRequest }: BottombarProps) => {
    /** Hide "Mark as complete" btn if request status is already COMPLETED */
    const showMarkAsCompleteBtn = userType === Roles.REQUESTOR && request?.status !== STATUSES.COMPLETED.toUpperCase();
    const disableMarkAsCompleteBtn = request?.status === STATUSES.CREATION_APPROVAL_IN_PROGRESS;
    const uploaded = products?.filter((it) => (it?.medias?.length || 0) > 0);
    const disableApproveButton = pending !== 0 || disableMarkAsCompleteBtn;
    return (
        <div className="container flex justify-between">
            <div className="flex">
                <div className="mr-9">
                    <h1 className="text-gray-500 whitespace-no-wrap text-base uppercase">status</h1>
                    <div className="text-gray-900 whitespace-no-wrap text-base capitalize"> {request && STATUSES[request.status]}</div>
                </div>
                <div className="mr-9">
                    <h1 className="text-gray-500 whitespace-no-wrap text-base uppercase">total</h1>
                    <div className="text-gray-900 whitespace-no-wrap text-base capitalize">{products?.length} Products</div>
                </div>
                <div className="mr-9">
                    <h1 className="text-gray-500 whitespace-no-wrap text-base uppercase">uploaded</h1>
                    <div className="text-gray-900 whitespace-no-wrap text-base capitalize">{uploaded?.length} Products</div>
                </div>
                <div className="mr-9">
                    <h1 className="text-gray-500 whitespace-no-wrap text-base uppercase">approved</h1>
                    <div className="text-gray-900 whitespace-no-wrap text-base capitalize">{approved} Products</div>
                </div>

                <div className="mr-9">
                    <h1 className="text-gray-500 whitespace-no-wrap text-base uppercase">pending approval</h1>
                    <div className="text-gray-900 whitespace-no-wrap text-base capitalize">{pending} Products</div>
                </div>

                {/* <div className=" mr-9">
                    <h1 className="text-gray-500 whitespace-no-wrap text-base uppercase">rejected</h1>
                    <div className="text-gray-900 whitespace-no-wrap text-base capitalize">{rejected} Products</div>
                </div> */}
            </div>
            <div className="flex justify-end gap-4 w-1/4">
                {showMarkAsCompleteBtn && (
                    <IconButton disabled={disableApproveButton} fullWidth label="Mark as Complete" onClick={handleSubmitRequest}>
                        <svg width="18" height="13" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M5.99965 10.1698L2.52965 6.69982C2.13965 6.30982 1.50965 6.30982 1.11965 6.69982C0.729648 7.08982 0.729648 7.71982 1.11965 8.10982L5.29965 12.2898C5.68965 12.6798 6.31965 12.6798 6.70965 12.2898L17.2896 1.70982C17.6796 1.31982 17.6796 0.689824 17.2896 0.299824C16.8996 -0.0901758 16.2696 -0.0901758 15.8796 0.299824L5.99965 10.1698Z"
                                fill="white"
                            />
                        </svg>
                    </IconButton>
                )}
                {/* <IconButton fullWidth label="Notify Partner" onClick={handleSubmitRequest}>
                    <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M8 20C9.1 20 10 19.1 10 18H6C6 19.1 6.9 20 8 20ZM14 14V9C14 5.93 12.37 3.36 9.5 2.68V2C9.5 1.17 8.83 0.5 8 0.5C7.17 0.5 6.5 1.17 6.5 2V2.68C3.64 3.36 2 5.92 2 9V14L0 16V17H16V16L14 14ZM12 15H4V9C4 6.52 5.51 4.5 8 4.5C10.49 4.5 12 6.52 12 9V15Z"
                            fill="white"
                        />
                    </svg>
                </IconButton> */}
            </div>
        </div>
    );
};
export default ProductsBottombar;
